export default { sha: '6bcad670bfd4ab499504d91f93fd64bf0bb44d2d', buildNumber: 'undefined' }
